import type { HTMLAttributes } from "react";

import { cn } from "@/lib/utils";

export default function InputError({
  message,
  className = "",
  ...props
}: HTMLAttributes<HTMLParagraphElement> & { message?: string | string[] }) {
  const displayMessage = Array.isArray(message) ? message[0] : message;

  return displayMessage ? (
    <p
      {...props}
      className={cn("text-sm text-red-600 dark:text-red-400", className)}
    >
      {displayMessage}
    </p>
  ) : null;
}
